import { render } from "./OptionYesNoComponent.vue?vue&type=template&id=716f2624&ts=true"
import script from "./OptionYesNoComponent.vue?vue&type=script&lang=ts"
export * from "./OptionYesNoComponent.vue?vue&type=script&lang=ts"

import "./OptionYesNoComponent.vue?vue&type=style&index=0&id=716f2624&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__